export default __webpack_public_path__ + "staticlp1/media/faca-parte-do-clube-video-thumbnail.e181db62.png";